import React from 'react';
import { connect } from 'react-redux';
import pageWrapper from '../../hoc/pageWrapper';
import { fetchApartments } from '../../actions/apartmentsActions';
import useOnMount from '../../hooks/useOnMount';
import ApartmentListFilters from '../../components/apartmentListFilters';
import ApartmentsList from '../../components/apartmentsList';
import * as StyledApartments from './apartments.styles';
import { getType} from '../../helpers/linkResolver/linkResolver';

const Apartments = ({
	loading,
	error,
	filteredApartments,
	apartments,
	selectedLocations,
	selectedPrices,
	dispatch,
	match
}) => {
	useOnMount(() => {
		if(filteredApartments === null && !loading && !error) {
			 const type = getType(match.url)
				dispatch(fetchApartments(type));
		}
	});

	return (
		<StyledApartments.ApartmentsWrapper>
			<ApartmentListFilters
				dispatch={dispatch}
				priceFiltersActive={selectedPrices.length > 0}
				locationFiltersActive={selectedLocations.length > 0}
				apartmentCount={apartments !== null ? apartments.length : 0} />
			<ApartmentsList
				error={error}
				apartments={filteredApartments}
				loading={loading} />
		</StyledApartments.ApartmentsWrapper>
	);
};

const mapStateToProps = (({ apartmentsReducer, filtersReducer }) => ({
	loading: apartmentsReducer.loading,
	error: apartmentsReducer.error,
	filteredApartments: apartmentsReducer.filteredApartments,
	apartments: apartmentsReducer.apartments,
	selectedLocations: filtersReducer.selectedLocations,
	selectedPrices: filtersReducer.selectedPrices
}));

export default connect(mapStateToProps, null)(pageWrapper(Apartments));
